<template>
  <section class="user">
    <header>
      <mo-pageheader>
        <template slot="title">
          Mon compte
        </template>
      </mo-pageheader>
    </header>
    <main>
      <!-- TABS SECTIONS -->
      <div class="tabs-ctn flex flex-center">
        <div
          v-if="accessProfil"            
          class="tab"
          :class="activeTab == 'profile' ? 'active': ''"
          @click="activeTab = 'profile'"
        >
          Profil
        </div>
        <div
          v-if="accessMonEntreprise"
          class="tab"
          :class="activeTab == 'company' ? 'active': ''"
          @click="activeTab = 'company'"
        >
          Mon entreprise
        </div>
        <div
          v-if="accessMdp"
          class="tab"
          :class="activeTab == 'password' ? 'active': ''"
          @click="activeTab = 'password'"
        >
          Changer de mot de passe
        </div>
        <div
          v-if="accessAbo"        
          class="tab"
          :class="activeTab == 'subscription' ? 'active': ''"
          @click="activeTab = 'subscription'"
        >
          Abonnement
        </div>
        <div
          v-if="accessPaiement"
          class="tab"
          :class="activeTab == 'payment' ? 'active': ''"
          @click="activeTab = 'payment'"
        >
          Mode de paiement
        </div>
        <div
          v-if="$store.getters.getUser.email === 'xxxx'"
          class="tab"
          :class="activeTab == 'client-update' ? 'active': ''"
          @click="activeTab = 'client-update'"
        >
          Import des clients
        </div>
      </div>


      <!-- PROFILE SECTION -->
      <div
        v-show="activeTab == 'profile'"
        class="profile"
      >
        <form @submit.prevent="handleUpdateUser">
          <ba-card>
            <template slot="header">
              <span>Informations du centre</span>
            </template>
            <template>
              <div class="cols">
                <div class="col-4">
                  <ba-input
                    v-model="profile.company"
                    type="text"
                    label="Raison sociale"
                    disabled
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="profile.company_number"
                    type="text"
                    label="Numéro de client"
                    disabled
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="profile.siren"
                    type="text"
                    label="SIREN"
                    disabled
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="profile.country"
                    type="text"
                    label="Pays"
                    disabled
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="profile.address_number"
                    type="text"
                    label="Numéro de rue"
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="profile.address"
                    type="text"
                    label="Rue"
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="profile.zip_code"
                    type="text"
                    label="Code postal"
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="profile.city"
                    type="text"
                    label="Ville"
                  />
                </div>
              </div>
            </template>
            <template slot="footer">
              <div class="buttons-container flex flex-end">
                <ba-button
                  class="primary"
                  :disabled="profile.disabled"
                >
                  Sauvegarder
                </ba-button>
              </div>
            </template>
          </ba-card>
          <!-- Personal information section -->
          <ba-card class="personal-info-card">
            <template slot="header">
              <span>Informations personnelles</span>
            </template>
            <template>
              <div class="profile-card">
                <div>
                  <!-- Drag & drop section -->
                  <div class="img-ctn" style="text-align:center;margin:auto">
                    <img :src="profile.image_path" @error="defaultImage">
                  </div>
                  <div class="height-filepond">
                    <form
                      enctype="multipart/form-data"
                      @submit.prevent="uploadFile"
                    >
                      <file-pond
                        ref="pond"
                        name="pond"
                        style="background: #fff; width: 180px; margin-left:20px"
                        :label-idle="attachedFile.pondLabel"
                        :allow-multiple="false"
                        :max-file-size="attachedFile.maxFileSizeTrunc"
                        :label-file-type-not-allowed="'Fichier invalide'"
                        :file-validate-type-label-expected-types="''"
                        :label-max-file-size-exceeded="'Le fichier est trop lourd'"
                        :label-max-file-size="`La taille d'un fichier doit être de ${attachedFile.maxFileSizeTrunc} maximum`"
                        :allow-file-type-validation="true"
                        :accepted-file-types="attachedFile.pondAcceptedFileType"
                      />
                    </form>
                  </div>
                </div>

                <div class="cols inputs">
                  <div class="col-3">
                    <ba-select
                      v-model="profile.civility_id"
                      label="Civilité"
                      :allow-empty="true"
                      :empty-label="''"
                    >
                      <option
                        v-for="civility in civilities"
                        :key="`civility-${civility.id}`"
                        :value="civility.id"
                      >
                        {{ civility.code }}
                      </option>
                    </ba-select>
                  </div>
                  <div class="col-3">
                    <ba-input
                      v-model="profile.last_name"
                      type="text"
                      label="Nom"
                    />
                  </div>
                  <div class="col-3">
                    <ba-input
                      v-model="profile.first_name"
                      type="text"
                      label="Prénom"
                    />
                  </div>
                  <div class="col-3">
                    <ba-input
                      v-model="profile.email"
                      type="text"
                      label="Email"
                    />
                  </div>
                  <div class="col-3">
                    <ba-input
                      v-model="profile.phone"
                      type="text"
                      label="Numéro de téléphone"
                    />
                  </div>
                </div>
              </div>
            </template>
            <template slot="footer">
              <div class="buttons-container flex flex-end">
                <ba-button
                  class="primary"
                  :disabled="profile.disabled"
                >
                  Sauvegarder
                </ba-button>
              </div>
            </template>
          </ba-card>
        </form>

      </div>

      <!-- COMPANY SECTION -->
      <div
        v-show="activeTab == 'company'"
        class="company"
      >
        <!-- Message d'absence : dates de fermeture -->
        <ba-card
          v-if="accessAjoutMessageAbsence"
          class="closure-card"
        >
          <template slot="header">
            <span>Message d'absence</span>
          </template>
          <template>
            <div class="cols">
              <div class="col-2">
                <section class="basic-date">
                  <label>Date de début de fermeture</label>
                  <datepicker
                    v-model="closure.closure_start"
                    class="basic-datepicker"
                    format="dd/MM/yyyy"
                    :highlighted="highlighted"
                    :monday-first="true"
                    :language="fr"
                    :disabled-dates="{}"
                  />
                  <ab-icon
                    icon="calendar"
                    iconset="calendarSet"
                  />
                </section>
              </div>
              <div class="col-2">
                <section class="basic-date">
                  <label>Date de fin de fermeture</label>
                  <datepicker
                    v-model="closure.closure_end"
                    class="basic-datepicker"
                    format="dd/MM/yyyy"
                    :highlighted="highlighted"
                    :monday-first="true"
                    :language="fr"
                    :disabled-dates="{}"
                  />
                  <ab-icon
                    icon="calendar"
                    iconset="calendarSet"
                  />
                </section>
              </div>
            </div>
          </template>
          <template slot="footer">
            <div class="buttons-container flex flex-end">
              <ba-button
                class="danger"
                :disabled="closure.disabled"
                @click.native="handleClearCompanyClosure"
              >
                Retirer les dates
              </ba-button>
              <ba-button
                class="primary"
                :disabled="closure.disabled"
                @click.native="handleUpdateCompanyClosure"
              >
                Sauvegarder
              </ba-button>
            </div>
          </template>
        </ba-card>
      </div>

      <!-- PASSWORD SECTION -->
      <div v-show="activeTab == 'password'">
        <form @submit.prevent="handleUpdatePassword">
          <ba-card>
            <template slot="header">
              <span>Changement de mot de passe</span>
            </template>
            <template>
              <div class="cols inputs">
                <div class="col-3">
                  <ba-input
                    v-model.trim="password.current_pwd"
                    type="password"
                    class="mandatory"
                    label="Mot de passe actuel"
                  />
                </div>
                <div class="col-3">
                  <ba-input
                    v-model.trim="password.new_pwd"
                    type="password"
                    class="mandatory"
                    label="Nouveau mot de passe"
                  />
                </div>
                <div class="col-3">
                  <ba-input
                    v-model.trim="password.confirm_pwd"
                    type="password"
                    class="mandatory"
                    label="Confirmation nouveau mot de passe"
                  />
                </div>
              </div>
            </template>
            <template slot="footer">
              <div class="buttons-container flex flex-end">
                <ba-button
                  class="primary"
                  :disabled="password.disabled"
                >
                  Sauvegarder
                </ba-button>
              </div>
            </template>
          </ba-card>
        </form>
      </div>

      <!-- SUBSCRIPTION SECTION -->
      <div
        v-show="activeTab == 'subscription'"
        class="subscription"
      >
        <ba-card>
          <template slot="header">
            <span>Abonnement</span>
          </template>
          <template>
            <h6 class="main-title">
              ABONNEMENT ACTUEL
            </h6>
            <div class="flex-stretch">
              <div class="input-ctn">
                <div class="flex flex-space input-label">
                  <span class="label">Date de début</span>
                  <ba-input
                    v-model="subscription.start_date"
                    type="text"
                    disabled
                  />
                </div>
                <div class="flex flex-space input-label">
                  <span class="label">Date de fin</span>
                  <ba-input
                    v-model="subscription.end_date"
                    type="text"
                    disabled
                  />
                </div>
                <div class="subscription-part">
                  <span class="title">Commissions Réseau</span>
                  <div class="flex flex-space input-label">
                    <span class="label">Commission sur les achats TTC</span>
                    <ba-input
                      v-model="subscription.purchase_commission"
                      type="text"
                      disabled
                    />
                  </div>
                  <div class="flex flex-space input-label">
                    <span class="label">Commission sur les ventes TTC</span>
                    <ba-input
                      v-model="subscription.sale_commission"
                      type="text"
                      disabled
                    />
                  </div>
                </div>
                <div class="subscription-part">
                  <span class="title">Commissions Hors-Réseau</span>
                  <div class="flex flex-space input-label">
                    <span class="label">Commission sur les achats TTC</span>
                    <ba-input
                      v-model="subscription.network_purchase_commission"
                      type="text"
                      disabled
                    />
                  </div>
                  <div class="flex flex-space input-label">
                    <span class="label">Commission sur les ventes TTC</span>
                    <ba-input
                      v-model="subscription.network_sale_commission"
                      type="text"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="flex-1 info-ctn">
                <div class="info-card">
                  <span class="flex flex-space"><p><strong>LICENCE D'UTILISATION MENSUELLE</strong></p><p><strong>{{ subscription.monthly_amount }} € / mois</strong></p></span>
                  <p>(Abonnement de 12 mois - hors options)</p>
                  <ul>
                    <li>Consultation du stock des professionnels</li>
                    <li>Création d'un dossier à partir de la plaque d'immatriculation du véhicule</li>
                    <li>Accès aux données 3A et TecDoc ainsi qu'à la base de connaissance permettant une identification de la pièce</li>
                    <li>Gestion des achats et des ventes sur la plateforme</li>
                    <li>Gestion de votre base de données clients</li>
                  </ul>
                </div>
                <div class="info-card">
                  <p><strong>Utilisation des webservices 3A et TecDoc</strong></p>
                  <p>
                    L'application utilise les services 3A et TecDoc afin de constituer un dossier à partir de la plaque d'immatriculation du véhicule.<br>
                    Vous disposez de 200 interrogations mensuelles de plaque d'immatriculation différentes incluses dans l'abonnement mensuel.
                  </p>
                  <p>Au-delà de cette commande mensuelle, chaque nouvelle interrogation sera facturée au tarif ci-après</p>
                  <div class="flex flex-space">
                    <div>
                      <div>Interrogation 3A / TecDoc</div>
                      <div>200 recherches mensuelles</div>
                    </div>
                    <span>{{ subscription.int_aaa_tecdoc_month == 0 ? 'GRATUIT' : subscription.int_aaa_tecdoc_month }}</span>
                  </div>
                  <div class="flex flex-space space">
                    <div>
                      <div>Au-delà, dans le mois</div>
                      <div>1 interrogation 3A / TecDoc</div>
                    </div>
                    <span>{{ subscription.int_aaa_tecdoc_more }} HT</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </ba-card>
      </div>

      <!-- PAYMENT METHOD SECTION -->
      <div
        v-show="activeTab == 'payment'"
        class="payment"
      >
        <ba-card>
          <template slot="header">
            <span>Moyens de paiement</span>
          </template>
          <template>
            <h6 class="main-title">
              PRELEVEMENT BANCAIRE SEPA
            </h6>
            <div class="input-ctn">
              <div class="cols">
                <div class="col-2">
                  <ba-input
                    v-model="payment.iban"
                    type="text"
                    label="IBAN"
                    disabled
                  />
                </div>
                <div class="col-2">
                  <ba-input
                    v-model="payment.bic"
                    type="text"
                    label="BIC"
                    disabled
                  />
                </div>
              </div>
              <div class="col-1">
                <ba-input
                  v-model="payment.bank"
                  type="text"
                  label="BANQUE"
                  disabled
                />
              </div>
              <div class="cols no-margin">
                <div class="col-2">
                  <ba-input
                    v-model="payment.last_name"
                    type="text"
                    label="NOM"
                    disabled
                  />
                </div>
                <div class="col-2">
                  <ba-input
                    v-model="payment.first_name"
                    type="text"
                    label="PRENOM"
                    disabled
                  />
                </div>
              </div>
              <p>
                Pour modifier votre prélèvement bancaire, merci d'envoyer une demande à <span class="underline">contact@activcar.fr</span>
              </p>
            </div>
          </template>
        </ba-card>
      </div>

      <!-- CLIENT UPDATE SECTION -->
      <!-- /// PLUS UTILISE ///
      <div
        v-show="activeTab == 'client-update'"
        class="client-update"
      >
        <form
          enctype="multipart/form-data"
          @submit.prevent="uploadFile"
        >
          <ba-card>
            <template slot="header">
              <span>Import de fichier clients</span>
            </template>
            <template>
              <div class="input-ctn">
                <file-pond
                  ref="pond"
                  name="test"
                  :label-idle="attachedFile.pondLabel"
                  :allow-multiple="false"
                  :label-file-type-not-allowed="'Fichier invalide'"
                  :file-validate-type-label-expected-types="''"
                  :label-max-file-size-exceeded="'Le fichier est trop lourd'"
                  :allow-file-type-validation="true"
                  :accepted-file-types="attachedFile.pondAcceptedFileType"
                />
              </div>
            </template>
            <template slot="footer">
              <div class="buttons-container flex flex-end">
                <ba-button
                  class="primary"
                  :disabled="password.disabled"
                >
                  Importer
                </ba-button>
              </div>
            </template>
          </ba-card>
        </form>
      </div>
      -->
    </main>

    <ab-iconset iconset="user">
      <g id="camera">
        <path
          d="M5.5 7.33333C6.47202 7.33333 7.26 6.5374 7.26 5.55556C7.26 4.57372 6.47202 3.77778 5.5 3.77778C4.52798 3.77778 3.74 4.57372 3.74 5.55556C3.74 6.5374 4.52798 7.33333 5.5 7.33333Z"
          fill="white"
        />
        <path
          d="M3.85 0L2.8435 1.11111H1.1C0.495 1.11111 0 1.61111 0 2.22222V8.88889C0 9.5 0.495 10 1.1 10H9.9C10.505 10 11 9.5 11 8.88889V2.22222C11 1.61111 10.505 1.11111 9.9 1.11111H8.1565L7.15 0H3.85ZM5.5 8.33333C3.982 8.33333 2.75 7.08889 2.75 5.55556C2.75 4.02222 3.982 2.77778 5.5 2.77778C7.018 2.77778 8.25 4.02222 8.25 5.55556C8.25 7.08889 7.018 8.33333 5.5 8.33333Z"
          fill="white"
        />
      </g>
    </ab-iconset>
  </section>
</template>

<script>
import {
  AbIcon, AbIconset, BaButton, BaCard, BaInput, BaSelect
} from '@ab/basic-components';
import { mapState } from 'vuex';

import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import Datepicker from 'vuejs-datepicker';
import { fr } from 'vuejs-datepicker/dist/locale';

import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';

const FilePond = vueFilePond(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

export default {
  name: 'User',
  components: {
    AbIcon,
    AbIconset,
    BaButton,
    BaCard,
    BaInput,
    BaSelect,
    Datepicker,
    FilePond,
    MoPageheader
  },
  data() {
    return {
      accessProfil: false,
      accessMdp: false,
      accessAbo: false,
      accessPaiement: false,
      accessAjoutMessageAbsence: false,
      accessMonEntreprise: false,
      activeTab: 'profile',
      fr,
      highlighted: {
        dates: [ new Date() ]
      },
      closure: {
        closure_start: null,
        closure_end: null,
        disabled: false,
      },
      profile: {
        address: '',
        address_number: '',
        civility_id: '',
        city: '',
        country: '',
        company: '',
        company_number: '',
        email: '',
        first_name: '',
        image_path: '',
        last_name: '',
        phone: '',
        siren: '',
        zip_code: '',
        disabled: false,
      },
      password: {
        current_pwd: '',
        new_pwd: '',
        confirm_pwd: '',
        disabled: false,
      },
      subscription: {
        start_date: '',
        end_date: '',
        monthly_amount: 0,
        purchase_commission: '',
        sale_commission: '',
        network_purchase_commission: '',
        network_sale_commission: '',
        int_aaa_tecdoc_month: '',
        int_aaa_tecdoc_more: '',
      },
      payment: {
        iban: '',
        bic: '',
        bank: '',
        first_name: '',
        last_name: ''
      },
  // ancien upload des fiches client     
  //    attachedFile: {
  //      pondLabel: 'Glissez votre document ou <u>cliquez ici</u>',
  //      pondAcceptedFileType: [ 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ],
  //    },
      attachedFile: {
        fileId: null,
        fileStatus: '',
        maxFileSize: 10000000,
        maxFileSizeTrunc: '10 MB',
        pondLabel: "Glissez votre fichier ou <u>cliquez ici</u> format JPG, PNG, GIF",
        pondAcceptedFileType: ['image/jpeg', 'image/png', 'image/gif'],
        resultatImport:null
      },
    };
  },
  computed: {
    ...mapState({ civilities: state => state.users.civilities }),
    ...mapState({ companies: state => state.companies.companies }),
    ...mapState({ userSubscription: state => state.users.subscription }),
    ...mapState({ user: state => state.users.user }),
  },
  watch: {
    '$route.query.tab': function (newValue) {
      if (newValue === 'company' && this.accessMonEntreprise) {
        this.activeTab = 'company';
      }
    },
    user(newValue) {
      // Profile
      try {
        const [ number, address ] = newValue.Company ? newValue.Company.address_1.split(',') : '';
        this.profile.address = address ? address.trim() : '';
        this.profile.address_number = number ? number.trim() : '';
        this.profile.civility_id = newValue.Civility ? newValue.Civility.id : '';
        this.profile.city = newValue.Company.city;
        this.profile.country = newValue.Company ? newValue.Company.country : '';
        this.profile.company = newValue.Company ? newValue.Company.name : '';
        this.profile.company_number = newValue.Company ? newValue.Company.id : '';
        this.profile.email = newValue.email;
        this.profile.first_name = newValue.first_name;
        this.profile.image_path = this.getImage(newValue.image_path);
        this.profile.last_name = newValue.last_name;
        this.profile.phone = newValue.phone;
        this.profile.siren = newValue.Company.siren;
        this.profile.zip_code = newValue.Company.zip_code;
        // Payment
        this.payment.bank = newValue.Company ? newValue.Company.bank : '';
        this.payment.iban = newValue.Company ? newValue.Company.iban : '';
        this.payment.bic = newValue.Company ? newValue.Company.bic : '';
        this.payment.first_name = newValue.Company ? newValue.Company.payment_first_name : '';
        this.payment.last_name = newValue.Company ? newValue.Company.payment_last_name : '';
        // Closure dates (message d'absence)
        this.closure.closure_start = newValue.Company && newValue.Company.closure_start
          ? new Date(newValue.Company.closure_start) : null;
        this.closure.closure_end = newValue.Company && newValue.Company.closure_end
          ? new Date(newValue.Company.closure_end) : null;
      } catch (error) {
        console.log(error);
      }
    },
    userSubscription(newValue) {
      this.subscription.start_date = newValue ? this.$options.filters.dateInput(newValue.start_date) : '';
      this.subscription.end_date = newValue ? this.$options.filters.dateInput(newValue.end_date) : '';
      this.subscription.monthly_amount = newValue ? newValue.monthly_amount : 0;
      this.subscription.purchase_commission = newValue ? newValue.purchase_commission : '';
      this.subscription.sale_commission = newValue ? newValue.sale_commission : '';
      this.subscription.network_purchase_commission = newValue ? newValue.network_purchase_commission : '';
      this.subscription.network_sale_commission = newValue ? newValue.network_sale_commission : '';
      this.subscription.int_aaa_tecdoc_month = newValue ? newValue.int_aaa_tecdoc_month : '';
      this.subscription.int_aaa_tecdoc_more = newValue ? newValue.int_aaa_tecdoc_more : '';
    }
  },
  async mounted() {
    await this.$store.dispatch('getCivilities');
    await this.$store.dispatch('getCompanies');
 // ne dois plus servir & bug bo

    await this.$store.dispatch('getUserSubscription', this.$store.getters.getUser.company_id, this.$store.getters.getUserId);
    await this.$store.dispatch('getUser', this.$store.getters.getUserId);

    this.accessProfil = await this.$store.dispatch('getAccesRole', {search:24,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessMdp = await this.$store.dispatch('getAccesRole', {search:25,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessAbo = await this.$store.dispatch('getAccesRole', {search:26,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessPaiement = await this.$store.dispatch('getAccesRole', {search:27,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});

    this.accessAjoutMessageAbsence = await this.$store.dispatch('getAccesRole', {
      search: 42,
      role: this.$store.state.authentication.user.Role.id,
      data: this.$store.state.authentication.user.allDetailRole,
    });

    this.accessMonEntreprise = await this.$store.dispatch('getAccesRoleByLabel', {
      label: 'Mon entreprise',
      role: this.$store.state.authentication.user.Role.id,
      data: this.$store.state.authentication.user.allDetailRole,
    });

    this.selectInitialTab();

    this.$store.commit('setSpinner', false);
  },
  methods: {
    selectInitialTab() {
      if (this.$route.query.tab === 'company' && this.accessMonEntreprise) {
        this.activeTab = 'company';
        return;
      }
      if (this.accessProfil) { return; }
      if (this.accessMdp) { this.activeTab = 'password'; }
      else if (this.accessAbo) { this.activeTab = 'subscription'; }
      else if (this.accessPaiement) { this.activeTab = 'payment'; }
      else if (this.accessMonEntreprise) { this.activeTab = 'company'; }
    },
    async handleUpdateUser() {

      if(this.profile.email !== '') {
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.profile.email)) {
            return this.$store.dispatch('displaySnackbar', { text: `Veuillez entrer une adresse mail valide`, mode: 'error'})
        }
      }

      let formData = new FormData();
      if(this.$refs.pond.getFile() !=  null) {
         if (this.$refs.pond.getFile().fileSize > this.attachedFile.maxFileSize) {
          return this.$store.dispatch('displaySnackbar', { text: `Veuillez ajouter une image dont la taille de dépasse pas ${this.attachedFile.maxFileSizeTrunc}`, mode: 'error' });
        }

        // Check file type
        const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);
        if (typeof fileType == 'undefined') {
          return this.$store.dispatch('displaySnackbar', { text: `Veuillez sélectionner une image ayant un format valide`, mode: 'error' });
        }

        let file = this.$refs.pond.getFile().file;
        formData.append('fileUpload', file, file.name);
      }

      this.profile.disabled = true;
      const data = await this.$store.dispatch('updateUser', {
        id: this.$store.getters.getUserId,
        address: `${this.profile.address_number}, ${this.profile.address}`,
        civility: this.profile.civility_id,
        city: this.profile.city,
        country: this.profile.country,
        company: this.profile.company,
        company_id: this.$store.getters.getUser.company_id,
        email: (this.profile.email == '' ? ' ' : this.profile.email), 
        first_name: (this.profile.first_name == '' ? ' ' : this.profile.first_name),
        last_name: (this.profile.last_name == '' ? ' ' : this.profile.last_name),
        phone: (this.profile.phone == '' ? ' ' : this.profile.phone),
        siren: this.profile.siren,
        zip_code: this.profile.zip_code,
        data: formData,
      });
      if (data && data.id) {
        if(data.image_path) {
          this.profile.image_path = this.getImage(data.image_path)
        }
        this.$store.dispatch('displaySnackbar', { text: 'Les données ont été enregistrées' });
      } else {
        this.$store.dispatch('displaySnackbar', { text: 'Une erreur est survenue. Veuillez réessayer', mode: 'error' });
      }
      this.profile.disabled = false;
    },
    async handleClearCompanyClosure() {
      this.closure.disabled = true;
      const data = await this.$store.dispatch('updateCompanyClosure', {
        company_id: this.$store.getters.getUser.company_id,
        closure_start: null,
        closure_end: null,
      });
      this.closure.disabled = false;

      if (data && data.success) {
        this.closure.closure_start = null;
        this.closure.closure_end = null;
        return this.$store.dispatch('displaySnackbar', {
          text: 'Les dates de fermeture ont été retirées',
        });
      }
      return this.$store.dispatch('displaySnackbar', {
        text: 'Une erreur est survenue. Veuillez réessayer',
        mode: 'error',
      });
    },
    async handleUpdateCompanyClosure() {
      const start = this.closure.closure_start;
      const end = this.closure.closure_end;

      if (!start || !end) {
        return this.$store.dispatch('displaySnackbar', {
          text: 'Veuillez renseigner les dates de début et de fin de fermeture',
          mode: 'error',
        });
      }

      if (new Date(start) > new Date(end)) {
        return this.$store.dispatch('displaySnackbar', {
          text: 'La date de début doit être antérieure à la date de fin',
          mode: 'error',
        });
      }

      const toIsoDay = (d) => {
        if (!d) return null;
        const dt = new Date(d);
        const y = dt.getFullYear();
        const m = String(dt.getMonth() + 1).padStart(2, '0');
        const day = String(dt.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      };

      this.closure.disabled = true;
      const data = await this.$store.dispatch('updateCompanyClosure', {
        company_id: this.$store.getters.getUser.company_id,
        closure_start: toIsoDay(start),
        closure_end: toIsoDay(end),
      });
      this.closure.disabled = false;

      if (data && data.success) {
        return this.$store.dispatch('displaySnackbar', {
          text: 'Les dates de fermeture ont été enregistrées',
        });
      }
      return this.$store.dispatch('displaySnackbar', {
        text: 'Une erreur est survenue. Veuillez réessayer',
        mode: 'error',
      });
    },
    async handleUpdatePassword() {
      // If one of inputs is empty
      if (!this.password.current_pwd || !this.password.new_pwd || !this.password.confirm_pwd) {
        return this.$store.dispatch('displaySnackbar', { text: 'Veuillez remplir les champs obligatoires', mode: 'error' });
      }

      // If new password & confirmation don't have same value
      if (this.password.new_pwd !== this.password.confirm_pwd) {
        return this.$store.dispatch('displaySnackbar', { text: 'Le nouveau mot de passe et la confirmation ne sont pas identiques', mode: 'error' });
      }
      if (!this.password.new_pwd.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+=.;_{}<>|^£:"'])[A-Za-z\d@$!%*#?&+=.;_{}<>|^£:"']{8,}$/) || !this.password.confirm_pwd.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+=.;_{}<>|^£:"'])[A-Za-z\d@$!%*#?&+=.;_{}<>|^£:"']{8,}$/)) {
        return this.$store.dispatch('displaySnackbar', { text: "Votre mot de passe doit contenir au moins 8 caractères dont 1 lettre 1 chiffre et 1 caractère spécial", mode: 'error' });
      }
      this.password.disabled = true;
      const data = await this.$store.dispatch('changePassword', {
        user_id: this.$store.getters.getUserId,
        current_password: this.password.current_pwd.replaceAll('?', '‰‰'),
        password: this.password.new_pwd.replaceAll('?', '‰‰'),
        passwordConfirm: this.password.confirm_pwd.replaceAll('?', '‰‰'),
      });
      if (data && data.success) {
        return this.$store.dispatch('displaySnackbar', { text: 'Votre mot de passe a été modifié' });
      }
      if (data.message == 'CurrentPasswordNotCorrect') {
        return this.$store.dispatch('displaySnackbar', { text: 'Le mot de passe actuel ne correspond pas à celui enregistré. Veuillez réessayer', mode: 'error' });
      }
      return this.$store.dispatch('displaySnackbar', { text: 'Une erreur est survenue. Veuillez réessayer', mode: 'error' });

      this.password.disabled = false;
    },
    getImage(path) {
      const baseApi = process.env.VUE_APP_ROOT_API;
      return `${baseApi}/upload/user/${path}`;
    },
    /* Image for error case */
    defaultImage(e) {
      e.target.src = 'https://cdn.activcar.fr/media/64/brands/default.png';
    },
    async uploadFile() {
      // Check if file has been selected
      if (!this.$refs.pond.getFile()) {
        return this.$store.dispatch('displaySnackbar', { text: 'Veuillez ajouter un document', mode: 'error' });
      }

      // Check file type
      const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);
      if (typeof fileType === 'undefined') {
        return this.$store.dispatch('displaySnackbar', { text: 'Veuillez sélectionner document valide', mode: 'error' });
      }

      const { file } = this.$refs.pond.getFile();
      const formData = new FormData();
      formData.append('fileUpload', file, file.name);

      // Prevent from clicking on button during operation
      this.$store.commit('setSpinner', true);
      const data = await this.$store.dispatch('uploadFile', {
        data: formData,
      });
      if (data) {
        this.$store.dispatch('displaySnackbar', { text: 'Le document a bien été ajouté' });
      }
      this.$refs.pond.removeFile();
      this.$store.commit('setSpinner', false);
    },
  }
};
</script>

<style scoped>
/* Image */
/*.user .img-container {
  width: 64px;
  height: 64px;
  border: none;
  border-radius: 50%;
  overflow: hidden;
}
.user .img-container img {
  min-width: 100%;
}*/
/* -- Profile -- */
.user .personal-info-card { margin-top: 2rem; }
.user .closure-card { margin-top: 2rem; }
.user .company .closure-card { margin-top: 0; }
.user .profile-card {
  display: flex;
  align-items: start;
  padding-top: 2rem;
}
/* Image */
.user .profile .img-ctn {
  position: relative;
  width: 64px;
  height: 64px;
  border: none;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 1rem;
  cursor: pointer;
}
.user .profile .img-ctn img { width: 100%; }
.user .profile .img-picture {
  position: absolute;
  text-align: center;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000;
  opacity: 0.5;
}
/* Form display */
.user .profile .inputs { flex: 1; padding-top: 0;}

/* -- Subscription -- */
/* Inputs */
.user .subscription .input-ctn { padding: 0 0 2rem 3rem; }
.user .subscription .subscription-part { margin-top: 3rem; text-align: center; }
.user .subscription .title { font-size: 1.3rem; }
.user .subscription .input-label { margin-top: 2rem; }
.user .subscription .input-label .label { margin-right: 2rem; font-size: 0.79rem; }
/* Information card */
.user .subscription .info-ctn {
  padding: 0 3rem 2rem 4rem;
}
.user .subscription .info-card {
  padding: 1.5rem 2.5rem 2.5rem 2.5rem;
  background-color: var(--app-lightgrey-2-color);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  font-size: 0.79rem;
}
.user .subscription .info-card ul { padding: 0; }
.user .subscription .info-card:last-child { margin-top: 6.3rem; }
.user .subscription .info-card .space { margin-top: 1rem; }

/* -- Payment method -- */
.user .payment .input-ctn { padding: 0 2rem 2rem 2rem; }
.user .payment .input-ctn p { margin-left: 1rem; }
.user .payment .col-1 {
  padding: 0 1rem;
  padding-bottom: 1.5rem;
}
.user .payment .underline { text-decoration: underline; }

/* Main title for subscription & payment sections */
.user .subscription .main-title,
.user .payment .main-title {
  margin: 1rem 0 0 3rem;
  font-size: 1.3rem;
}

/* Button on card footer */
.user .buttons-container { padding: 0 1rem 1rem 1rem; }
</style>
<style src="@/assets/styles/tabs.css"></style>
<style src="@/assets/styles/filepond.css"></style>
<style src="@/assets/styles/datepickers.css"></style>
